var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67902 2.88889C3.24265 2.88889 2.88889 3.24265 2.88889 3.67902V12.321C2.88889 12.7574 3.24265 13.1112 3.67902 13.1112H12.321C12.7574 13.1112 13.1112 12.7574 13.1112 12.321V3.67902C13.1112 3.24265 12.7574 2.88889 12.321 2.88889H3.67902ZM2 3.67902C2 2.75172 2.75172 2 3.67902 2H12.321C13.2483 2 14.0001 2.75172 14.0001 3.67902V12.321C14.0001 13.2483 13.2483 14.0001 12.321 14.0001H3.67902C2.75172 14.0001 2 13.2483 2 12.321V3.67902Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7778 5.11113C5.4096 5.11113 5.11113 5.4096 5.11113 5.7778C5.11113 6.14599 5.4096 6.44447 5.7778 6.44447C6.14599 6.44447 6.44447 6.14599 6.44447 5.7778C6.44447 5.4096 6.14599 5.11113 5.7778 5.11113ZM4.22223 5.7778C4.22223 4.91868 4.91868 4.22223 5.7778 4.22223C6.63691 4.22223 7.33336 4.91868 7.33336 5.7778C7.33336 6.63691 6.63691 7.33336 5.7778 7.33336C4.91868 7.33336 4.22223 6.63691 4.22223 5.7778Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4301 6.44447C10.552 6.44434 10.6685 6.49423 10.7525 6.58247L13.8775 9.86532C14.0468 10.0431 14.0398 10.3244 13.862 10.4937C13.6843 10.6629 13.4029 10.656 13.2337 10.4782L10.4313 7.53424L4.43368 13.8614C4.26481 14.0395 3.98351 14.047 3.80536 13.8782C3.62722 13.7093 3.6197 13.428 3.78856 13.2499L10.108 6.58315C10.1919 6.49473 10.3083 6.44459 10.4301 6.44447Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.4d787b825a3aeebeaa772399ec4c2ef6.svg";
export { ForwardRef as ReactComponent };